<template>
    <div class="dd">
        <a class="dd-toggle h1" @click.prevent="isOpen=!isOpen">{{current.label}} <icon icon="chevron-down"/></a>
        <div class="dd-outer">
            <div v-if="isOpen" class="dd-menu shadow-lg">
                <a v-for="item in items" href="#" @click.prevent="chooseItem(item)" :key="item.key" class="dd-item h1">{{item.label}}</a>
            </div>
        </div>
    </div>
</template>

<script>

  import Icon from "./Icon";

  export default {
    name: "DropDownHeader",
    props: {
      items: {
        type: Array,
        required: true,
        default: [{key:'', label:'No Items'}]
      },
      selected: Object,
      callback: {
        type: Function,
        required: true
      }
    },
    data(){
      return {
        isOpen: false,
        current: {key:'', label:'No Items'},

      }
    },
    mounted(){
      if(this.selected){
        this.current = this.selected;
      } else {
        this.current = this.items[0];
      }
    },
    methods: {
      chooseItem(item){
        this.isOpen = false;
        this.current = item;
        this.callback(item);
      }
    },
    components: {
      Icon
    }

  }
</script>

<style scoped lang="sass">
    @import "../../assets/sass/vars.scss"

    .h1
        display: inline-block
        font-size: 2.5rem
        font-weight: 200
        text-align: center
        line-height: 1.1

    .dd
        position: relative
        width: auto
        margin: auto
        text-align: center
        -webkit-transform: translate3d(0,0,0)
        z-index: $z-dropDowns

    .dd-toggle
        margin-top:
        cursor: pointer

    .dd-outer
        position: absolute
        text-align: center
        width: 100%
        z-index: 2

    .dd-menu
        display: inline-block
        background-color: #FFF
        margin: auto

        box-shadow: 0 2px 8px rgba(0,0,0,.3)

        .dd-item
            padding: .2em 1em
            display: block
            color: #1b1e21

            &.h1
                font-size: 2rem
                margin-top: 0

            &:hover
                background-color: $colorBodyBg
                text-decoration: none
</style>



// WEBPACK FOOTER //
// src/components/ui/DropDownHeader.vue